"use client";

import { ReactNode } from "react";
import { toast } from "react-hot-toast";
import { cn } from "@/lib/utils";

interface ClickToCopyProps {
  copyVal?: string;
  children: ReactNode;
  className?: string;
  stopPropagation?: boolean;
  testId?: string;
}

export function ClickToCopy({
  copyVal,
  children,
  className,
  stopPropagation = false,
  testId,
}: ClickToCopyProps) {
  const handleClick = async (event: React.MouseEvent<HTMLSpanElement>) => {
    if (stopPropagation) event.stopPropagation();
    if (!children) return;

    const text = copyVal ?? (typeof children === "string" ? children : String(children));

    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied");
    } catch (error) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      toast.success("Copied");
    }
  };

  return (
    <span data-testid={testId} onClick={handleClick} className={cn("cursor-pointer", className)}>
      {children}
    </span>
  );
}
